import React from 'react'
import SocialButtons from './SocialButtons'
import { motion } from "framer-motion";
import ScrollTo from "react-scroll-into-view";
import { MDBBtn } from 'mdb-react-ui-kit';
import NavigationButton from './NavigationButton';

const Contacts = () => {
  return (
    <motion.div initial={{ opacity: 0}} whileInView={{ opacity: 1}}  transition={{ delay: 0.2, duration: 2}} >
        <section id="contacts" className="section-image-bg">
            <div className="row section-full-frame d-flex justify-content-start align-content-center">
                <div className="col-sm-12 d-flex justify-content-center align-items-center mb-5">
                        <NavigationButton mySelector="#perfect-getaway" myIcon="chevron-up" hasMargin={false}/>
                </div>
                <div className="col-sm-12 d-flex flex-column justify-content-center align-items-center">
                    <h1>Contact us</h1>
                    <p>Your reservation can be done through a simple phone call or email</p>
                    <p>+351 123 456 789</p>
                    <p>info@the-perfect-getaway.com</p>
                </div>
                <div className="col-sm-12 d-flex justify-content-center mt-5">
                    <SocialButtons />
                </div>
                <div className="col-sm-12 d-flex justify-content-center align-items-center mt-5">
                    <ScrollTo selector="#hero">
                        <MDBBtn outline rounded className='mx-2 social-button' color='secondary'>
                            Back to top
                        </MDBBtn>
                    </ScrollTo>
                </div>
            </div>
        </section>
    </motion.div>
  )
}

export default Contacts
